// preview 專用：快速連結「新版呈現」（精簡版）。
// 串接同原本（useCRUDController('/app/rwd_function')），只改呈現：
// 精簡卡（小圖示＋名稱）＋ 2 欄自動網格 → 不再過長、單卡不過大。
// 不動共用元件 quick_links_section → 舊頁維持原樣。
import { useEffect } from "react";
import { useCRUDController, ImageFileId } from "../../ui/ot";
import { Globe } from "lucide-react";

const QuickLinksV2 = () => {
  const ctrl = useCRUDController({ apiRoute: "/app/rwd_function", onBefore: () => {} });
  useEffect(() => {
    ctrl.getData({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const links = ctrl?.ResponseData || [];

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
        gap: "8px",
      }}
    >
      {links.map((link, idx) => {
        const file_id = (link?.file_data || []).find((e) => true)?.file_id;
        return (
          <a
            key={idx}
            href={link?.rwd_function_url}
            target="_blank"
            rel="noopener noreferrer"
            title={link?.description || link?.rwd_function_name}
            style={{
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              gap: "9px",
              background: "#fff",
              borderRadius: "10px",
              padding: "8px 10px",
              boxShadow: "0 1px 5px rgba(0,0,0,0.06)",
              borderLeft: "3px solid transparent",
              transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 5px 14px rgba(30,58,138,0.15)";
              e.currentTarget.style.borderLeftColor = "#2563eb";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 1px 5px rgba(0,0,0,0.06)";
              e.currentTarget.style.borderLeftColor = "transparent";
            }}
          >
            <div
              style={{
                flexShrink: 0,
                width: "30px",
                height: "30px",
                borderRadius: "8px",
                background: "linear-gradient(135deg,#eff6ff,#dbeafe)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              {file_id ? (
                <ImageFileId file_id={file_id} className="w-5 h-5 object-contain" />
              ) : (
                <Globe size={17} color="#1e3a8a" />
              )}
            </div>
            <span
              style={{
                fontWeight: 600,
                color: "#1e3a8a",
                fontSize: "0.8rem",
                lineHeight: 1.25,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {link?.rwd_function_name}
            </span>
          </a>
        );
      })}
    </div>
  );
};

export default QuickLinksV2;
